
























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class ModalContainer extends Vue {
  @Prop(Boolean) showDialog!: boolean;
  @Prop(Function) onClosed!: Function;
  @Prop(Number) width!: number;
  @Prop({ type: Boolean, default: false }) disableClose!: boolean;
}
